import React, { useEffect, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import DeleteModal from "components/Common/DeleteModal"
import ProviderListComponent from "components/Provider/list"
import {
  deleteProvider,
  exportProviders,
  getProviders,
} from "store/providers/provider-action"

const ProviderList = () => {
  const dispatch = useDispatch()
  const { data, error, loading, exportStatus } = useSelector(
    state => state.provider
  )
  const [deleteModal, setDeleteModal] = useState(false)
  const [provider, setProvider] = useState(null)
  const [search, setSearch] = useState(null)
  const [pageNumber, setPageNumber] = useState(10)
  const [according, setAccording] = useState({ order: "desc", name: "id" })

  // Handle provider deletion and close the delete modal
  // Dispatch delete action for the selected provider
  // Close the delete modal
  const handleDeleteFunc = data => {
    if (provider) {
      dispatch(deleteProvider(provider.id))
    }
    setDeleteModal(false)
  }

  // Set the provider to be deleted and open the delete modal
  // Store the selected provider for deletion
  // Open the delete confirmation modal
  const onClickDelete = data => {
    setProvider(data)
    setDeleteModal(true)
  }

  // Fetches new activity logs when a page number is clicked
  const onPageClick = link => {
    dispatch(getProviders(link.url, pageNumber, according, search))
  }

  // Updates search value when a new search is performed
  const onSearchHandler = value => {
    setSearch(value)
  }

  // Updates the number of rows displayed based on user selection (e.g., 10, 20, 50)
  const onChangeRowNumber = value => {
    setPageNumber(value)
  }

  // Updates the ordering based on user selection
  const onChangeOrdering = value => {
    if (value.order) {
      setAccording(prev => {
        return { ...prev, order: value.order }
      })
    }
    if (value.name) {
      setAccording(prev => {
        return { ...prev, name: value.name }
      })
    }
  }

  // fetch new Provider Distribution Action Requests based search change
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      dispatch(getProviders(undefined, undefined, undefined, search))
    }, 1500)

    return () => clearTimeout(delayDebounceFn)
  }, [search])

  // fetch new Provider Distribution Action Requests based page number and according change
  useEffect(() => {
    dispatch(getProviders(undefined, pageNumber, according, search))
  }, [pageNumber, according])

  // Trigger export process when Export button is clicked
  const onExportBtnClick = () => {
    dispatch(exportProviders(search))
  }

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteFunc}
        onCloseClick={() => setDeleteModal(false)}
      />
      <Breadcrumbs title={"Admin"} breadcrumbItem={"Provider"} />

      <ProviderListComponent
        data={data}
        error={error}
        loading={loading}
        onClickDelete={onClickDelete}
        handleDeleteFunc={handleDeleteFunc}
        onPageClick={onPageClick}
        onSearch={onSearchHandler}
        onChangeRowNumber={onChangeRowNumber}
        onChangeOrdering={onChangeOrdering}
        onExportBtnClick={onExportBtnClick}
        exportStatus={exportStatus}
      />
    </React.Fragment>
  )
}

export default ProviderList
